<div class="p8-rds_settings__container">
  <mat-drawer-container class="p8-rds_settings__drawer-container global__mat-drawer-custom">
    <mat-drawer class="mat-elevation-z1" [mode]="sidenavMode" [opened]="opened">
      <div class="p8-rds-settings_link" routerLinkActive="active" [routerLink]="['users/']"><mat-icon class="md-18">people</mat-icon> Utilisateurs</div>
      <div class="p8-rds-settings_link" routerLinkActive="active" [routerLink]="['entites/']"><mat-icon class="md-18">domain</mat-icon> Entités</div>
    </mat-drawer>
    <mat-drawer-content>
      <router-outlet></router-outlet>
    </mat-drawer-content>
  </mat-drawer-container>
</div>
